import { type HTMLAttributes, type ReactNode, type Ref } from 'react';
import clsx from 'clsx';
import './BottomNav.css';

export interface BottomNavProps extends HTMLAttributes<HTMLElement> {
  'aria-label': string;
  children: ReactNode;
  ref?: Ref<HTMLElement>;
}

/**
 * BottomNav — sticky-bottom tab bar shell. Framework-agnostic: it provides
 * the fixed-position chrome, safe-area padding, and equal-width slot
 * layout. Consumers render their router's link primitive (e.g. react-router
 * `NavLink`) as children, applying `.fluent-bottomnav__item` for layout
 * and `.is-active` (or `aria-current="page"`) for the selected state.
 *
 * Icon + label vertical stack inside each item; brand-green active treatment.
 */
export function BottomNav({
  className,
  children,
  ref,
  ...rest
}: BottomNavProps) {
  return (
    <nav ref={ref} className={clsx('fluent-bottomnav', className)} {...rest}>
      <div className="fluent-bottomnav__row">{children}</div>
    </nav>
  );
}
